import {
  createFetchActionForNamespace,
  createPostActionForNamespace,
  createReducer,
  createFetchReducers
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('teams/detail');
const createPostAction = createPostActionForNamespace('teams/detail');

export const fetchTeamDetail = createFetchAction({
  name: 'FETCH_TEAM_DETAILS',
  initialAction: ({teamId}, extraActions = []) => ({
    payload: {teamId, extraActions}
  })
});

export const fetchTeamPermissions = createFetchAction({
  name: 'FETCH_TEAM_PERMISSIONS',
  initialAction: ({teamId}, extraActions) => ({
    payload: {teamId, extraActions}
  })
});

export const editTeamPermissions = createPostAction({
  name: 'EDIT_TEAM_PERMISSIONS',
  initialAction: (
    {teamId, possitivePermissionEntities, negativePermissionEntities},
    extraActions
  ) => ({
    payload: {
      teamId,
      possitivePermissionEntities,
      negativePermissionEntities,
      extraActions
    }
  }),
  formName: 'manageTeamPermissions'
});

export const editTeamDetails = createPostAction({
  name: 'EDIT_TEAM_DETAILS',
  initialAction: ({id, name, avatar}, extraActions = []) => ({
    payload: {
      id,
      name,
      avatar,
      extraActions
    }
  }),
  formName: 'editTeamDetails'
});

export const addTeamLocation = createPostAction({
  name: 'ADD_TEAM_LOCATION',
  initialAction: ({locationRef, teamId}, extraActions = []) => ({
    payload: {
      locationRef,
      teamId,
      extraActions
    }
  })
});

export const removeTeamLocation = createPostAction({
  name: 'REMOVE_TEAM_LOCATION',
  initialAction: ({locationRef, teamId}, extraActions = []) => ({
    payload: {
      locationRef,
      teamId,
      extraActions
    }
  })
});

export const addMemberToTeam = createPostAction({
  name: 'ADD_MEMBER_TO_TEAM',
  initialAction: ({memberId, teamId}, extraActions = []) => ({
    payload: {
      memberId,
      teamId,
      extraActions
    }
  })
});

export const removeMemberFromTeam = createPostAction({
  name: 'REMOVE_MEMBER_FROM_TEAM',
  initialAction: ({memberId, teamId}, extraActions = []) => ({
    payload: {
      memberId,
      teamId,
      extraActions
    }
  })
});

export const demoteTeamOwner = createPostAction({
  name: 'DEMOTE_TEAM_OWNER',
  initialAction: ({memberId, teamId}, extraActions = []) => ({
    payload: {
      memberId,
      teamId,
      extraActions
    }
  })
});

export const promoteTeamOwner = createPostAction({
  name: 'PROMOTE_TEAM_OWNER',
  initialAction: ({memberId, teamId}, extraActions = []) => ({
    payload: {
      memberId,
      teamId,
      extraActions
    }
  })
});

export const deleteTeam = createPostAction({
  name: 'DELETE_TEAM',
  initialAction: ({teamId}, extraActions = []) => ({
    payload: {
      teamId,
      extraActions
    }
  })
});

export const fetchStaffMember = createFetchAction({
  name: 'FETCH_STAFF_MEMBER',
  initialAction: ({memberId}, extraActions) => ({
    payload: {memberId, extraActions}
  })
});

export const activateUser = createPostAction({
  name: 'ACTIVATE_USER',
  initialAction: ({userId}, extraActions = []) => ({
    payload: {
      userId,
      extraActions
    }
  })
});

export const deactivateUser = createPostAction({
  name: 'DEACTIVATE_USER',
  initialAction: ({userId}, extraActions = []) => ({
    payload: {
      userId,
      extraActions
    }
  })
});

export const resendAdminInvitation = createPostAction({
  name: 'RESEND_ADMIN_INVITATION',
  initialAction: ({adminId}, extraActions = []) => ({
    payload: {
      adminId,
      extraActions
    }
  }),
  formName: 'resendInvitation'
});

export const resetAdminPassword = createPostAction({
  name: 'RESET_ADMIN_PASSWORD',
  initialAction: ({adminId}, extraActions = []) => ({
    payload: {
      adminId,
      extraActions
    }
  }),
  formName: 'resetPassword'
});

export const setInactivityLogoutTimer = createPostAction({
  name: 'SET_INACTIVITY_LOGOUT_TIMER',
  initialAction: (
    {teamId, inactivityTimer, forceLogout},
    extraActions = []
  ) => ({
    payload: {
      teamId,
      inactivityTimer,
      forceLogout,
      extraActions
    }
  }),
  formName: 'setInactivityLogoutTimer'
});

const initialState = {};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducers(fetchTeamDetail),
  ...createFetchReducers(fetchTeamPermissions)
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {default as teamsDetailSaga} from './saga';
